import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseJsHover from 'js/modules/_base/events/mouse/hover/BaseJsHover'

const defaults = {
  instanceName: 'panel1Hover',
  $names: {
    target: '[data-js-hover=panel1]',
    thumb: '.teams_list-member_panel_thumb_img',
    text: '.teams_list-member_panel_body',
  },
  classNames: {
    iconInner: 'c-btn-more_icon_inner',
  },
  styleInfo: {
    alphaHovered: 0.5,
    alphaDefault: 1,
    scaleHovered: 1.05,
    scaleDefault: 1,
  },
}

export default class Panel1Hover extends BaseJsHover {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      const $thumb = $target.querySelector(this.$names.thumb)
      const $text = $target.querySelector(this.$names.text)

      if ($thumb) {
        gsap.killTweensOf($thumb, 'transform')
        gsap.to($thumb, {
          scale: this.styleInfo.scaleHovered,
          duration: 0.65,
          ease: 'cubic.out',
        })
      }

      if ($text) {
        gsap.killTweensOf($text, 'opacity')
        gsap.to($text, {
          opacity: this.styleInfo.alphaHovered,
          duration: 0.5,
          ease: 'quart.out',
        })
      }

      gsap.delayedCall(0.4, () => {
        resolve()
      })
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      const $thumb = $target.querySelector(this.$names.thumb)
      const $text = $target.querySelector(this.$names.text)

      if ($thumb) {
        gsap.killTweensOf($thumb, 'transform')
        gsap.to($thumb, {
          scale: this.styleInfo.scaleDefault,
          duration: 0.6,
          ease: 'none',
          delay: 0.05,
        })
      }

      if ($text) {
        gsap.killTweensOf($text, 'opacity')
        gsap.to($text, {
          opacity: this.styleInfo.alphaDefault,
          duration: 0.6,
          ease: 'none',
          delay: 0.05,
        })
      }

      resolve()
    })
  }
}